module.exports = __webpack_public_path__ + "static/media/betson-screenshot-1.8f93b9df.png";